import { render, staticRenderFns } from "./ModalPromocao.vue?vue&type=template&id=51138f5e&scoped=true&"
import script from "./ModalPromocao.vue?vue&type=script&lang=js&"
export * from "./ModalPromocao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51138f5e",
  null
  
)

export default component.exports